module.exports = __webpack_public_path__ + "img/monitor_U.73d6f6e0.png";